/**
* =========================================================================================
* Component - Icon
* ========================================================================================= 
**/

import React from 'react';
import { hexToRgba } from '../common/function';


const UIcon = (props) => {

    const handle = {
        styles: () => {
            return {
                width: props?.thumb, 
                height: props?.thumb,
                borderColor: props?.color
            }
        }, 
        bgColor: () => {
            return {
                backgroundColor: props?.color ? hexToRgba(props?.color, 0.1) : '',
                color: props?.color,
                border: `1px solid ${hexToRgba(props?.color, 0.2)}`,
            }
        }
    }

    return ( 
        <React.Fragment>
            
            <div className="u_round-icon u_p-2" style={handle.styles()}>
                <div className={`u_round-icon-inner u_icon-color ${props?.type === 'square' ? 'u_square-icon' : ''}`} style={handle.bgColor()}>
                    { props?.icon }
                </div>
            </div>
                    
        </React.Fragment>
    );
}
 
export default UIcon;